import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Open Source Projects`}</h2>
    <ProjectCard title="BMSTU App" link="https://github.com/CaioF/bmstu-app" bg="linear-gradient(to right, #141821 0%, #020024 100%)" mdxType="ProjectCard">
A PDF generator that compiles title pages in accordance with BMSTU's standards. This project is my entry to GitHub's #ArticCodeVault.<br /> Built with React.js & Node.js
    </ProjectCard>
    <ProjectCard title="Oily Silicon" link="https://github.com/CaioF/Silicondzor" bg="linear-gradient(to right, #141821 0%, #020024 100%)" mdxType="ProjectCard">
Web app that uses machine learning to analyze data and display predictions from an oil mining operation. This is my entry to the #CET-MIPT hackathon.<br /> Built with Scikit-learn & Node.js
    </ProjectCard>
    <ProjectCard title="Match Predictor" link="https://drive.google.com/file/d/1LeRiJix-tWuDQ_pxP7NO_KzwKDHSWuPv/view?usp=sharing" bg="linear-gradient(to right, #141821 0%, #020024 100%)" mdxType="ProjectCard">
Data analysis project that trains a multi-layer neural network to predict football match results.<br /> Built with Jupyter & Tensorflow
    </ProjectCard>
    <ProjectCard title="Grants & Keywords" link="https://www.kaggle.com/caiofleury/ec-europa-grants" bg="linear-gradient(to right, #141821 0%, #020024 100%)" mdxType="ProjectCard">
Data analysis project that scrapes the European Commision's grantsg and extracts their keywords.<br /> Built with Jupyter & Selenium & Scikit-learn
    </ProjectCard>
    <ProjectCard title="Mongo-Express-Start" link="https://github.com/CaioF/mongo-express-start" bg="linear-gradient(to right, #141821 0%, #020024 100%)" mdxType="ProjectCard">
A generator for a webapp server based on express, mongo and many other things. <br /> Built with Node.js & Express & Mongo
    </ProjectCard>
    <ProjectCard title="This Portfolio Website" link="https://github.com/CaioF/CaioF.github.io" bg="linear-gradient(to right, #141821 0%, #020024 100%)" mdxType="ProjectCard">
This portfolio website is openly hosted on GitHub :)<br /> Built with Gatsby.js
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      